
const loadEditorChart = () => import('editor-chart').then(module => module.default);
export const chart_editor = loadEditorChart
const loadRenderMarkdownCodehighlight = () => import('render-markdown-codehighlight').then(module => module.default);
export const render_markdown_codehighlight = loadRenderMarkdownCodehighlight